export default "__VITE_ASSET__C3Px2xfb__"